import utils from '../../js/utils/utils';

export default ($user_logged_in, $order_complete = false) => ({
    tab: 1,
    showSteps: false,
    orderComplete: $order_complete,
    init() {
        if ($order_complete) {
            this.tab = 5;
            this.showSteps = true;
        } else if ($user_logged_in) {
            this.tab = 2;
            this.showSteps = true;
        }
    },
    formValidator(input_container) {

        var form = document.querySelector('form[name="checkout"]');
        let valid = true;

        if (form) {
            let input_containers = input_container.querySelectorAll('.validate-required');

            for (var i = 0; i < input_containers.length; i++) {

                let input = input_containers[i].querySelector('input');

                input.dispatchEvent(new Event('change', {
                    bubbles: true
                }));

                if (utils.hasClass(input_containers[i], 'woocommerce-invalid')) {
                    valid = false;
                }
            }
        }

        if (valid) {
            document.body.dispatchEvent(new Event('update_checkout', {
                bubbles: true
            }));
        }

        return valid;
    },
    setStep(step) {

        if (this.orderComplete) {
            return false;
        }

        if (step == 1) {
            if (!$user_logged_in) {
                this.tab = step;
                this.showSteps = false
            }
        } else if (step == 3) {
            if (this.formValidator(document.getElementById('woocommerce-checkout-billing'))) {
                this.tab = step;
                this.showSteps = true
            }
        } else if (step == 4) {

            let proceed = true;

            if (document.getElementById('ship-to-different-address').querySelector('input').checked) {
                if (!this.formValidator(document.getElementById('woocommerce-checkout-shipping'))) {
                    proceed = false;
                }
            }

            if (!this.formValidator(document.querySelector('.woocommerce-additional-fields'))) {
                proceed = false;
            }

            if (proceed && this.formValidator(document.getElementById('woocommerce-checkout-billing'))) {

                let billing_address = '';
                billing_address += document.querySelector('input[name="billing_first_name"]').value + " " + document.querySelector('input[name="billing_last_name"]').value;
                let billing_company = document.querySelector('input[name="billing_company"]');
                if (billing_company.value) {
                    billing_address += "<br />" + billing_company.value;
                }
                billing_address += "<br />" + document.querySelector('input[name="billing_address_1"]').value;
                let billing_address_2 = document.querySelector('input[name="billing_address_2"]');
                if (billing_address_2.value) {
                    billing_address += "<br />" + billing_address_2.value;
                }
                billing_address += "<br />" + document.querySelector('input[name="billing_city"]').value;
                billing_address += "<br />" + document.querySelector('input[name="billing_postcode"]').value;

                let billing_placeholder = document.getElementById('static-billing-address');
                billing_placeholder.innerHTML = billing_address;

                let shipping_address = '';
                shipping_address += document.querySelector('input[name="shipping_first_name"]').value + " " + document.querySelector('input[name="shipping_last_name"]').value;
                let shipping_company = document.querySelector('input[name="shipping_company"]');
                if (shipping_company.value) {
                    shipping_address += "<br />" + shipping_company.value;
                }
                shipping_address += "<br />" + document.querySelector('input[name="shipping_address_1"]').value;
                let shipping_address_2 = document.querySelector('input[name="shipping_address_2"]');
                if (shipping_address_2.value) {
                    shipping_address += "<br />" + shipping_address_2.value;
                }
                shipping_address += "<br />" + document.querySelector('input[name="shipping_city"]').value;
                shipping_address += "<br />" + document.querySelector('input[name="shipping_postcode"]').value;

                let shipping_placeholder = document.getElementById('static-delivery-address');
                shipping_placeholder.innerHTML = shipping_address;

                this.showSteps = true
                this.tab = step
            }
        } else {
            this.tab = parseInt(step)

            if (step == 1) {
                this.showSteps = false
            } else {
                this.showSteps = true
            }
        }

    }
});